import { isEqual, differenceWith } from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import pagesModel from '@/mixins/pages-model';
import repliersModel from '@/mixins/repliers-model';
import { mapGetters } from 'vuex';
import filtersModel from '@/mixins/filters-model';
import sacTypeModel from '@/mixins/sac-type-model';
import { FILTER_NAMES } from '@/store/modules/cards/constants';

export default {
  mixins: [
    pagesModel,
    repliersModel,
    filtersModel,
    sacTypeModel,
  ],
  computed: {
    ...mapGetters('filter', [
      'filterByDataType',
    ]),
    filterTitleLabel() {
      return `${this.filterLabel} - ${this.card.props.title}`;
    },
    showClearFilter() {
      return Object.keys(this.appliedFilter).length;
    },
  },
  created() {
    this.globalFilterByDataType = this.filterByDataType[this.card.dataType];
    this.globalFilterByDataTypeToShow = this.globalFilterByDataType;

    const isCardFilter = 'filter' in this.card.props;

    if (isCardFilter) {
      this.appliedFilter = cloneDeep(this.card.props.filter);
      this.tempFilter = cloneDeep(this.card.props.filter);
      this.channels = this.tempFilter.channels?.value || [];

      const keysToUse = differenceWith(Object.keys(this.globalFilterByDataType), Object.keys(this.tempFilter), isEqual);

      this.globalFilterByDataTypeToShow = Object.fromEntries(Object.entries(this.globalFilterByDataType).filter(global => keysToUse.includes(global[0])));
    }
  },
  methods: {
    closeDialog() {
      this.$emit('input', false);
    },
    clearFilter() {
      const sacTypeList = this.getAllSacType();

      this.$emit('applyFilter', { sac_type: {
        value: ['All', ...sacTypeList],
      } });

      this.closeDialog();
    },
    applyFilter() {
      // Sanatize before send
      for (const k in this.tempFilter) {
        if (!this.tempFilter[k]) delete this.tempFilter[k];
      }

      if (!this.tempFilter.hasOwnProperty(FILTER_NAMES.SAC_TYPE)) {
        const sacTypeList = this.getAllSacType();
        this.tempFilter.sac_type = { value: ['All', ...sacTypeList] };
      }

      this.$emit('applyFilter', this.tempFilter);
      this.closeDialog();
    },
    getAllSacType() {
      const sacTypeList = [];
      Object.keys(this.typesObj).forEach(function(key) {
        sacTypeList.push(key);
      });
      return sacTypeList;
    },
    clearChangesFilter() {
      this.tempFilter = cloneDeep(this.appliedFilter);
      this.changeOnPageFilter = false;
    },
    generateObjectToFilter(value) {
      return {
        text: value,
        value,
      };
    },
    displayClearable(componentKey) {
      return Boolean(this.showGlobalFilterFeature && this.globalFilterByDataType?.hasOwnProperty(componentKey));
    },
  },
};
